import React, { createContext, useReducer } from 'react';
import * as actions from './Actions';
import initialState from "./initialState.json"

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
    const [state, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case actions.LOADER_ACTIVE:
                return {
                    ...state,
                    loader: !state.loader
                }
            case actions.STATE_CHANGE:
                return {
                    ...state,
                    [action.key]: action.value
                };
            default:
                // Blocker 3: return state instead of throwing so unknown actions don't crash the app
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('[Store] Unknown action type dispatched:', action);
                }
                return state;
        };
    }, initialState);

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider }
